module.exports = __webpack_public_path__ + "img/1527271617.1e30abfa.jpg";